<template>
  <div :class="specialPageCarouselClass">
    <template v-if="carousel_data.length > 1">
      <section class="grid">
        <div class="grid-group" v-for="item in carousel_data" :key="item.id">
          <div class="grid-group-image">
            <img :src="item.url" :alt="item.alt" width="328" height="160" />
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Swiper, SwiperSlide } from 'swiper/vue';
import "swiper/swiper-bundle.css";
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay
} from "swiper";
SwiperClass.use([Pagination, Mousewheel, Autoplay]);

import { mapState } from "vuex";
import commons from "@/common/store/modules/commons";

@Options({
  name: "SpecialPageColumn",
  props: {
    cms_response: { type: Object, default: null },
    view_area: { type: String, default: "" },
    special_category: { type: String, default: null },
    show_more: { type: Boolean, default: true }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  ...mapState({
    colorCode: () => commons.colorCode
  })
})
export default class SpecialPageCarousel extends Vue {
  cms_response!: object;
  view_area!: string;
  special_category!: string;
  show_more!: boolean;

  data: any = null;
  carousel_data: any = [];
  colorCode!: string;

  get colors(): string {
    return this.colorCode;
  }

  get specialPageCarouselClass() {
    return this.show_more
      ? "specialPageCarousel__Showmore"
      : "specialPageCarousel";
  }

  mounted() {
    this.makeCarouselData(this.cms_response);
  }

  makeCarouselData(obj: any) {
    if (!obj || !obj.included) {
      return;
    }
    this.carousel_data = [];

    const included = obj.included;
    const itemType = included.filter((el: any) => el.type === "file--file");
    const special_categories = included.filter(
      (el: any) => el.type === "taxonomy_term--special_category"
    );

    const catList: { category_id: any; category_code: any }[] = [];
    special_categories.forEach((category: any) => {
      catList.push({
        category_id: category.id,
        category_code: category.attributes.field_tag_code
      });
    });

    if (itemType !== null) {
      const data = obj.data;
      const dataList: {
        title: string;
        alias: string;
        alt: string;
        id: string;
        url: string;
        filename: string;
        publish_location: string;
        special_category: any[];
      }[] = [];

      data.forEach((item: any) => {
        const imageSrc = included.find(
          (el: any) => el.id === item.relationships.field_banner.data.id
        );
        const category_data = item.relationships.special_category.data;

        const category_data_ids: {
          data_category_id: any;
          data_category_code: any;
        }[] = [];
        category_data.forEach((category_data_id: any) => {
          const findName: any = catList.find(
            (el: { category_id: number; category_code: string }) =>
              el.category_id === category_data_id.id
          );
          category_data_ids.push({
            data_category_id: category_data_id.id,
            data_category_code: findName.category_code
          });
        });

        dataList.push({
          title: item.attributes.title,
          alias: item.attributes.alias,
          alt: item.relationships.field_banner.data.meta.alt,
          id: item.relationships.field_banner.data.id,
          url:
            process.env.VUE_APP_CMS_ASSET_DOMAIN + imageSrc.attributes.uri.url,
          filename: imageSrc.attributes.filename,
          publish_location: item.attributes.publish_location,
          special_category: category_data_ids
        });
      });
      this.toMatchSpecial_category(dataList);
    }
  }

  toMatchSpecial_category(data: any) {
    const dataList: any[] = [];

    if (this.special_category === "point") {
      data.forEach((catItem: any) => {
        catItem.special_category.forEach((item: any) => {
          if (item.data_category_code === "point") {
            dataList.push(catItem);
          }
        });
      });
      this.toMatchViewAreaData(dataList);
    } else if (this.special_category === "relax_and_beauty") {
      data.forEach((catItem: any) => {
        catItem.special_category.forEach((item: any) => {
          if (item.data_category_code === "relax_and_beauty") {
            dataList.push(catItem);
          }
        });
      });
      this.toMatchViewAreaData(dataList);
    } else if (this.special_category === null) {
      data.forEach((catItem: any) => {
        dataList.push(catItem);
      });
      this.toMatchViewAreaData(dataList);
    }
  }

  toMatchViewAreaData(data: any) {
    if (this.view_area === "top") {
      data.forEach((listItem: any) => {
        listItem.publish_location.forEach((item: any) => {
          if (item === "Home") {
            this.carousel_data.push(listItem);
          }
        });
      });
    } else if (this.view_area === "list") {
      data.forEach((listItem: any) => {
        listItem.publish_location.forEach((item: any) => {
          if (item === "Listing") {
            this.carousel_data.push(listItem);
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.specialPageCarousel__more {
  text-align: right;
  font-size: 0.875rem;
}
img {
  width: 100%;
  height: 160px;
  display: block;
}

.section-title {
  text-transform: uppercase;
  color: gold;
  border-bottom: 1px solid #222;
  padding-bottom: 1rem;
  margin-bottom: 2rem;
}
@media (min-width: 500px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 2rem;
  }
}

@media (min-width: 800px) {
  .grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.grid-group {
  margin-bottom: 3rem;
}
@media (min-width: 500px) {
  .grid-group {
    margin-bottom: 0;
  }
}

.grid-group-meta {
  margin: 2rem 0;

  h3,
  h4 {
    margin: 0;
  }
  h3 {
    margin-bottom: 0.5rem;
    text-transform: uppercase;
  }
  h4 {
    font-style: italic;
  }
}
.grid-group-text {
  p {
    line-height: 1.5;
    text-align: justify;
  }
}
</style>
